import s from './List.scss'
import MaterialTable, { MTableBodyRow } from '@material-table/core'
import { getUser, getCurrency, isAdmin } from 'utils/authService'
import { toTeams } from 'utils/serializers'
import { NumericFormat } from 'react-number-format'
import { FaRedoAlt, FaUserSecret } from 'react-icons/fa'

const columns = [
  { title: 'Name', field: 'userName', defaultSort: 'asc' },
  { title: 'Email', field: 'email' },
  {
    title: 'Role(s)',
    field: 'roles',
    render: row =>
      row.roles
        .map(role => {
          switch (role) {
            case 'ROLE_ADMIN':
              return 'Administrator'
            case 'ROLE_USER':
              return 'User'
            case 'ROLE_PROPOSALREVIEWER':
              return 'Proposal Reviewer'
            case 'ROLE_TIMETRACKER_ADMIN':
              return 'Time Tracker Admin'
            case 'ROLE_TIMETRACKER':
              return 'Time Tracker User'
            default:
              return ''
          }
        })
        .join(', ')
  },
  {
    title: 'Teams',
    field: 'teams',
    render: row =>
      row.teams
        ? toTeams(row.teams)
            .map(t => t.label)
            .join(', ')
        : ''
  },
  {
    title: 'Department',
    field: 'department',
    render: row => (row.department ? row.department.name : '')
  },
  {
    title: 'Monthly Quota',
    field: 'monthlyQuota',
    render: row =>
      row.monthlyQuota ? (
        <NumericFormat
          thousandSeparator
          decimalScale={2}
          value={row.monthlyQuota}
          prefix={getCurrency().symbol}
          displayType="text"
        />
      ) : (
        ''
      )
  },
  {
    title: 'Yearly Quota',
    field: 'yearlyQuota',
    render: row =>
      row.yearlyQuota ? (
        <NumericFormat
          thousandSeparator
          decimalScale={2}
          value={row.yearlyQuota}
          prefix={getCurrency().symbol}
          displayType="text"
        />
      ) : (
        ''
      )
  },
  {
    title: 'Monthly Target Profit',
    field: 'monthlyTargetProfit',
    render: row =>
      row.monthlyTargetProfit ? (
        <NumericFormat
          thousandSeparator
          decimalScale={2}
          value={row.monthlyTargetProfit}
          prefix={getCurrency().symbol}
          displayType="text"
        />
      ) : (
        ''
      )
  },
  {
    title: 'Yearly Target Profit',
    field: 'yearlyTargetProfit',
    render: row =>
      row.yearlyTargetProfit ? (
        <NumericFormat
          thousandSeparator
          decimalScale={2}
          value={row.yearlyTargetProfit}
          prefix={getCurrency().symbol}
          displayType="text"
        />
      ) : (
        ''
      )
  }
]

const List = ({
  users,
  removeUser,
  openEditUser,
  reactivateUser,
  impersonateUser
  /* resendEmail */
}) => {
  const currentUser = getUser()
  const currentUserIsAdmin = isAdmin()

  return (
    <div className={s.listWrapper}>
      <MaterialTable
        title="Current Users:"
        columns={columns}
        data={users}
        components={{
          Row: props => <MTableBodyRow id={`user_row_${props.data.id}_cy`} {...props} />
        }}
        options={{
          actionsColumnIndex: -1,
          sorting: true,
          headerStyle: {
            backgroundColor: '#eee',
            color: '#000',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            fontSize: '14px'
          },
          maxBodyHeight: '400px',
          pageSize: 20,
          padding: 'dense'
        }}
        style={{
          boxShadow: 'none',
          fontSize: '14px'
        }}
        actions={
          openEditUser
            ? [
                rowData => ({
                  icon: () => <FaUserSecret />,
                  tooltip: 'Login As User',
                  onClick: (event, rowData) => impersonateUser(rowData.id),
                  hidden:
                    !currentUserIsAdmin ||
                    rowData?.id === currentUser?.id ||
                    rowData?.roles?.includes('ROLE_ADMIN')
                }),
                () => ({
                  icon: 'edit',
                  tooltip: 'Edit User',
                  onClick: (event, rowData) => openEditUser(rowData)
                }),
                rowData => ({
                  icon: 'delete',
                  tooltip: 'Delete User',
                  onClick: (event, rowData) => removeUser(rowData.id, rowData.email),
                  disabled: rowData?.id === currentUser?.id
                })
                // rowData => ({
                //   icon: 'email',
                //   tooltip: 'Resend Notification Email',
                //   onClick: (event, rowData) => resendEmail(rowData.id),
                //   disabled: rowData.id === getUser().id
                // })
              ]
            : reactivateUser
              ? [
                  () => ({
                    icon: () => <FaRedoAlt />,
                    tooltip: 'Reactivate User',
                    onClick: (event, rowData) => reactivateUser(rowData.id, rowData.email)
                  })
                ]
              : []
        }
      />
    </div>
  )
}

export default List
